module.exports = __webpack_public_path__ + "img/horizontal_7_3_6000.941be6d3.png";